import { UserSessionDataForm } from "./login/user-session-data-form";
import { ProjectDataForm } from "./project-data-form";
import { SessionActivityDataForm } from "./session-activity-data-form";


export class PatentDrawingDataForm {

    patentDrawingId: number;
    drawings: String;
    fileName: String;
    userSessionDataForm: UserSessionDataForm;
    projectDataForm: ProjectDataForm;
    sessionActivityDataForm :SessionActivityDataForm
  

}
